import {
  Component,
  OnInit
} from '@angular/core';
import { GraphQlQueryExecutor } from '../../operators/graphql/query-executor/graphql-query-executor.operator';
import { map, Observable, of } from 'rxjs';
import { GraphQlQuery, IGraphQlService } from '../../services/GraphQl/IGraphQL.service';



@Component({
  selector: 'listpage',
  templateUrl: './listpage.component.html',
  styleUrls: ['./listpage.component.css']
})
export class ListPageComponent implements OnInit {

  reports: Observable<any[]> = of<GraphQlQuery>({
    dataset: "eveCustomisableReportsPage",
    selects: [
      {
        field: "iD"
      },
      {
        field: "name",
      },
      {
        field: "companyId",
      },
      {
        field: "data",
      },
      {
        field: "createDate",
      },
    ],
    wheres: [],
    groupBys: [],
    page: 0,
    pageSize: -1
  }).pipe(
    GraphQlQueryExecutor(of(this.graphQlService)),
    map(data => data.result.data.eveCustomisableReportsPage.items)
  );

  constructor(
    public graphQlService: IGraphQlService,
  ) {
  }



  ngOnInit(): void {

  }


  deleteReport(id: number, reports:any[]) {
    this.graphQlService.executeGraphQl("\
      mutation{\
      deleteReport(\
        id: "+ id +" \
      ) {\
        name\
        iD\
      }\
    }\ "
    ).subscribe(() => {
      alert("delete done");

      const pos = reports.findIndex(r => r.iD == id);
      if (pos > -1) reports.splice(pos, 1);
    })
  }


}
